module.exports = __webpack_public_path__ + "img/sushi7.ce6bf27b.png";